/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { OptionHoverService } from '@ng-falcon/controls/option/option-hover.service';
import { OptionsRootHolder } from '@ng-falcon/controls/option/options-root-holder';

@Component({
    selector: 'ngf-options-container',
    templateUrl: './options-container.component.html',
    styleUrls: ['./options-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OptionsContainerComponent implements OnInit {

  @Input() ariaMultiselectable: boolean | null = null;

  @Input() ariaLabelledby: string | null = null;

  @Input() ariaLabel: string | null = null;

  constructor(public hoverService: OptionHoverService,
              private rootHolder: OptionsRootHolder) {
  }

  /** The container's own label wins; otherwise the listbox is named by its OptionsRoot (e.g. the autocomplete's combobox label). */
  get listboxLabelledby(): string | null {
    if (this.ariaLabelledby || this.ariaLabel) {
      return this.ariaLabelledby;
    }
    return this.rootListboxAriaLabelledby();
  }

  ngOnInit(): void {
    // Default to the OptionsRoot's multiselect flag so multi-select listboxes
    // announce per-option selected/not-selected state to screen readers.
    if (this.ariaMultiselectable !== null) {
      return;
    }
    try {
      if (this.rootHolder.get().multiselect) {
        this.ariaMultiselectable = true;
      }
    } catch {
      // OptionsRoot not resolvable in this DI context (e.g. tests with partial setup).
      // Consumers can still pass ariaMultiselectable explicitly.
    }
  }

  private rootListboxAriaLabelledby(): string | null {
    try {
      return this.rootHolder.get().listboxAriaLabelledby ?? null;
    } catch {
      // OptionsRoot not resolvable in this DI context (e.g. tests with partial setup).
      return null;
    }
  }
}
